import React from 'react';
import { FieldArray } from 'formik';
import AddIcon from '@mui/icons-material/Add';
import { IconButton } from '@mui/material';
import { v4 as uuidv4 } from 'uuid';

import SettlementFields from './SettlementFields';
import { DocumentDirection } from '../../config/DocumentDirection';

const SettlementForm = (props) => {
  const { defaultSettlementLine, documentData, selectedValuesState, defaultSettlementMode } = props;
  const { selectedValues } = selectedValuesState;

  const addRow = (push) => {
    defaultSettlementLine.id = uuidv4();
    defaultSettlementLine.baseType = documentData.documentTypeId;
    defaultSettlementLine.baseId = selectedValues.docId;
    defaultSettlementLine.direction = documentData.direction === DocumentDirection.INCOMING ? 'OUT' : 'IN';
    defaultSettlementLine.currency = selectedValues.currencyCode;
    defaultSettlementLine.mode = defaultSettlementMode?.code ?? null;

    push(defaultSettlementLine);
  };

  return (
    <FieldArray name="settlement">
      {({ remove, push }) => (
        <>
          <IconButton onClick={() => addRow(push)} size="small" variant="contained" color="primary" sx={{ my: 1 }}>
            <AddIcon />
            Új hozzáadása
          </IconButton>
          <SettlementFields remove={remove} {...props} />
        </>
      )}
    </FieldArray>
  );
};

export default SettlementForm;
